import { PropsWithChildren } from 'react'

import { OneOnOnesRootContextDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { OneOnOnesContext } from './OneOnOnesContext'

export const OneOnOnesContextProvider = ({ children }: PropsWithChildren) => {
  const { data, loading } = useQuery(OneOnOnesRootContextDocument)
  const session = useCurrentSession()

  const value = {
    canSeeOneOnOnes:
      (data?.oneOnOnes._policies.sidebarSeePerformanceOneOnOnesSubLevelItem.can ?? false) &&
      !!session.employee,
    loading,
  }

  return <OneOnOnesContext.Provider value={value}>{children}</OneOnOnesContext.Provider>
}
